<template>
  <div>
    <div class="marquee-wrap" ref="marqueeWrap" @click="stopIt">
      <div class="scroll">
        <div class="group" v-if="show">
          <i class="icon icon-loudspeakers"></i>
          <div v-for="(item, index) in $store.state.notice" :key="index" class="item">{{ item.em_message }}</div>
        </div>
        <div class="group" ref="showGroup">
          <i class="icon icon-loudspeakers"></i>
          <div v-for="(item, index) in $store.state.notice" :key="index" class="item">{{ item.em_message }}</div>
        </div>
      </div>
    </div>
    <noticePopup v-if="state" @clickClose="clickClose" :noticeList="$store.state.notice"/>
  </div>
</template>

<script>
import noticePopup from '@/components/common/noticePopup';

export default {
  name: "notice",
  data() {
    return {
      interva: null,
      state: false,
      show: false,
      noticeList: []
    };
  },
  mounted() {
    // 先判断滚不滚,滚的话直接开始
    this.autoScroll();
    // 注册上滚动事件
    this.$refs.marqueeWrap.addEventListener('scroll', this.marqueeWrapScroll, false)
  },
  methods: {
    autoScroll() {
      const marqueeWrap = this.$refs.marqueeWrap;
      const paddingLeft = parseFloat(window.getComputedStyle(marqueeWrap)["paddingLeft"]);
      const marqueeWrapWithinWidth = marqueeWrap.clientWidth - paddingLeft * 2;
      const showGroup = this.$refs.showGroup;
      if (marqueeWrapWithinWidth < showGroup.offsetWidth) {
        this.show = true;
        this.interva = setInterval(() => {
          marqueeWrap.scrollLeft += 1;
        }, 50);
      };
    },
    marqueeWrapScroll(e) {
      const { scrollLeft } = e.target;
      const marqueeWrap = this.$refs.marqueeWrap;
      const showGroup = this.$refs.showGroup;
      if (showGroup.offsetLeft <= scrollLeft) {
        marqueeWrap.scrollLeft = 0;
      }
    },
    stopIt() {
      clearInterval(this.interva);
      this.state = true;
    },
    clickClose() {
      this.state = false;
      this.autoScroll();
    },
    clearCache(){
      clearInterval(this.interva);
      this.$refs.marqueeWrap.removeEventListener('scroll', this.marqueeWrapScroll);
    }
  },
  components: {
    noticePopup
  },
  watch: {
    state(newValue){
      this.$beyondHiding(newValue)
    },
    '$store.state.notice': {
      handler(newValue){
        if(!newValue.length){
          this.state = false;
        }
      },
      immediate: true,
    },

  },
  beforeDestroy(){
    // 页面离开时候，销毁缓存
    this.clearCache();
  }
};
</script>

<style scoped lang='less'>
.marquee-wrap {
  background: #F9E9E8;
  display: flex;
  padding: 0 0.346667rem;
  align-items: center;
  height: 0.346667rem * 2;
  overflow-x: scroll;
  border-radius: 0.16rem 0.16rem 0 0;
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .scroll {
    display: flex;
    align-items: center;
    position: relative;
    .group {
      display: flex;
      align-items: center;
    }
    i {
      width: 0.346667rem;
      height: 0.32rem;
      margin-right: 0.16rem;
      flex-shrink: 0;
    }
    .item {
      margin-right: 0.666667rem;
      color: #dd4200;
      font-size: 0.32rem;
      white-space: nowrap;
    }
  }
}
</style>
